import React from 'react';

const FilterSection = ({ 
  title, 
  expanded, 
  onToggle, 
  onClose, 
  children,
  className = "" 
}) => {
  return (
    <div className={`mb-3 ${className}`}>
      <div 
        className="flex justify-between items-center cursor-pointer p-2 hover:bg-slate-50 rounded-xl transition-colors duration-200"
        onClick={onToggle}
      >
        <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
        {expanded ? (
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="text-slate-400 hover:text-slate-600 transition-colors duration-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        ) : (
          <svg className="w-5 h-5 text-slate-400 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        )}
      </div>
      
      {expanded && (
        <div className="mt-2 p-3 bg-slate-50 rounded-xl border border-slate-200 animate-fadeIn">
          {children}
        </div>
      )}
    </div>
  );
};

export default FilterSection;
